
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { routes } from 'environments/environment';
// import { AppLoaderService } from './app-loader/app-loader.service';
// import { AppConfirmService } from './app-confirm/app-confirm.service';
// import { AppContractsService } from './app-contracts/app-contracts.service';
// import { LocalStorageService } from 'ngx-webstorage';
// import { Router } from '@angular/router';

@Injectable()
export class ChatService {
  constructor(
    private http: HttpClient,
    // private loader: AppLoaderService,
    // private confirm: AppConfirmService,
    // private contracts: AppContractsService,
    // private localStorage: LocalStorageService,
    // private router: Router
  ) {}


    sendMessage(data) {
        return this.http.post(`${routes.whatsapp}`, data);
    }

}
